import localizationService from './localization.service';

export {
  localizationService
};